import { Outlet } from "react-router-dom";
import Navbar from "../component/Navbar";
import Footer from "../component/Footer";
import WhatsAppFloatingIcon from "../component/WhatsAppFloatingIcon ";


export default function MainLayout() {
  return (
    <div className="flex flex-col min-h-screen">
      {/* <Navbar /> */}
      <Navbar/>
      <main className="flex-grow">
        <Outlet />
      </main>
      <Footer/>
      <WhatsAppFloatingIcon/>
    </div>
  );
}
